import React, {useEffect, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import * as queryString from 'query-string';
import * as device from 'react-device-detect';
import Parser from 'html-react-parser';


const Recommand = (props: RouteComponentProps<{ id: string }>) => { // 추가
    const location = props.location;
    const search = queryString.parse(location.search);
    const act = 'download', type = 'Recom', q = search.q;
    const isAndroid = device.isAndroid;
    const isiOS = device.isIOS || device.isIOS13 || device.isIPhone13 || device.isIPad13;
    const androidPackage = process.env.REACT_APP_ANDROID_PACKAGE;
    const appleAppId = process.env.REACT_APP_APPLE_PACKAGE;
    const iosMarketUrl = `https://itunes.apple.com/kr/app/apple-store/${appleAppId}?mt=8`;
    const iosLink = `jstamp://main?act=${act}&t=${type}&q=${q}`;
    const androidLink = `intent://main?act=${act}&t=${type}&q=${q}#Intent;scheme=jstamp;package=${androidPackage};end`;
    const inigMsg='앱 실행중입니다.';
    const [msg,setMsg]=useState(inigMsg);
    function goNextPost() {
        //const nextPostId = Number(props.match.params.postId) + 1;
        console.log('query=', search);
        // msg +=`ios=${device.isIOS},android=${device.isAndroid}`;
        if (isAndroid) {
            setMsg('안드로이드 ' + inigMsg);
            window.location.assign(androidLink);
        } else if (isiOS) {
            let ds = 0;
            setMsg('아이폰 ' + inigMsg);
            setTimeout(function () {
                const ans = window.confirm("앱스토어로 이동하시겠습니까?");
                if (ans === true) {
                    window.location.href = iosMarketUrl;
                }
            }, 2000);
            window.location.replace(iosLink);

        } else {
            setMsg(`아이폰 또는 안드로이드폰에서만 실행이 가능합니다.<br />고객님의 접속기기는 [${device.deviceType}] 입니다.`);
        }
    }
    useEffect(()=>{
        if (search.q) {
            goNextPost();

        }else{
            setMsg('잘못된 접근 입니다.');
        }
        //return ()=>{ setMetaTags({}); }

    },[]);


    return (
        <>

            <div className="bloc l-bloc" id="bloc-0">
                {/*<h3>Post {props.match.params.id}</h3>*/}
                {/*<button onClick={()=>goNextPost(v)}>Next post</button>*/}
                {/*<p>{new URLSearchParams(props.location.search).get('body')}</p>*/}
                <div className="app-run">{Parser(msg)}</div>
            </div>
        </>
    );
};

export default Recommand;
